import { Alert, AlertDescription } from '@/components/ui/alert';
import { CheckCircle2, AlertCircle } from 'lucide-react';

interface ConnectionTestAlertProps {
  success: boolean;
  message: string;
}

/**
 * Standardized alert for displaying connection test results.
 * Shows green background for success, red background for failure.
 */
export function ConnectionTestAlert({ success, message }: ConnectionTestAlertProps) {
  return (
    <Alert
      className={
        success
          ? 'background-success border-success'
          : 'background-error border-error'
      }
    >
      {success ? (
        <CheckCircle2 className="h-4 w-4 text-success" />
      ) : (
        <AlertCircle className="h-4 w-4 text-error" />
      )}
      <AlertDescription className={success ? 'text-success' : 'text-error'}>
        {message}
      </AlertDescription>
    </Alert>
  );
}
